import { combineReducers } from 'redux';

import hooksReducer, * as fromHooks from './reducer.hooks';

export default combineReducers({
  hooks: hooksReducer,
});

// State accessors

export const getActiveHook = state => fromHooks.getActiveHook(state.hooks);
